import { Card, Typography, Icon } from '@cti-workspace/ui';

const defaultStyle = { backgroundColor: "#FF3D33", color: "white", display: "flex", textAlign: "center", alignItems: "center", justifyContent: "space-around", flex: 1, marginBottom: '20px' };

const WarningBanner = ({ text, style = defaultStyle, labelStyle = {} }) => {
	return (
		<Card elevation={5} style={style}>
			<style>
				{`
				@media (max-width: 630px) {
					.cred-revoke-banner-text {
						font-size: 1rem;
					}
				}
				`}
			</style>
			<Icon name="warning" size={32} />
			<Typography type="h5" color="white" className="cred-revoke-banner-text" style={labelStyle}>
				{text}
			</Typography>
			<Icon name="warning" size={32} />
		</Card>
	);
};

export default WarningBanner;
